import {
  SET_APPOINTMENT_ID,
  SET_USER_PREFERENCE,
  SET_SESSION_TYPE,
  SET_SESSION_STUDENT,
  SET_SESSION_DURATION,
  SET_SESSION_REMAINING_HOUR,
  SET_APPOINTMENT_FOR,
  SET_SESSION_DATE,
  SET_SESSION_START_TIME,
  RESET_SESSION_DATA,
  SET_COMMENT,
  SET_NOTES,
  SET_PRACTICE_WORK_GIVEN,
  SET_NEXT_DATE,
  SET_SHOW_REPORT_BUTTON,
  SET_PRACTICE_WORK_GIVEN_DETAIL,
  SET_SESSION_END_TIME

} from "../actions/sessionTypes";

const initialState = {
  appointmentId: null,
  userPreference: null,
  sessionType: null,
  sessionStudent: null,
  sessionDuration: null,
  sessionRemainingHour: null,
  appointmentFor: null,
  sessionDate: null,
  sessionStartTime: null,
   sessionEndTime: null,
   comment: null,
  notes: null,
  practice_work_given: null,
  nextdate: null,
  showReportButton: false,
  practice_work_given_detail: null
};

const sessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APPOINTMENT_ID:
      return { ...state, appointmentId: action.payload };
    case SET_USER_PREFERENCE:
      return { ...state, userPreference: action.payload };
    case SET_SESSION_TYPE:
      return { ...state, sessionType: action.payload };
    case SET_SESSION_STUDENT:
      return { ...state, sessionStudent: action.payload };
    case SET_SESSION_DURATION:
      return { ...state, sessionDuration: action.payload };
    case SET_SESSION_REMAINING_HOUR:
      return { ...state, sessionRemainingHour: action.payload };
    case SET_APPOINTMENT_FOR:
      return { ...state, appointmentFor: action.payload };
    case SET_SESSION_DATE:
      return { ...state, sessionDate: action.payload };
    case SET_SESSION_START_TIME:
      return { ...state, sessionStartTime: action.payload };
    case RESET_SESSION_DATA:
      return initialState;
        case SET_COMMENT:
      return { ...state, comment: action.payload };
    case SET_NOTES:
      return { ...state, notes: action.payload };
    case SET_PRACTICE_WORK_GIVEN:
      return { ...state, practice_work_given: action.payload };
    case SET_NEXT_DATE:
      return { ...state, nextdate: action.payload };
      case SET_SESSION_END_TIME:
  return { ...state, sessionEndTime: action.payload };

       case SET_SHOW_REPORT_BUTTON:
      return { ...state, showReportButton: action.payload };
      case SET_PRACTICE_WORK_GIVEN_DETAIL:
  return { ...state, practice_work_given_detail: action.payload };

    case RESET_SESSION_DATA:
      return initialState;
    default:
      return state;
  }
};

export default sessionReducer;
